import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from "@reach/combobox";

import "@reach/combobox/styles.css";
import { useEffect } from "react";

export default function SearchAuto({
  setLocation_text,
  setCordinate,
  location_text,
}) {
  const {
    value,
    suggestions: { status, data },
    setValue,
    init,
  } = usePlacesAutocomplete({
    initOnMount: false,
  });

  useEffect(() => {
    setValue(location_text);
  }, [location_text]);

  const handleInput = (e) => {
    setValue(e.target.value);
  };

  const handleSelect = (val) => {
    setLocation_text(val);
    setValue(val, false);

    getGeocode({ address: val })
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        setCordinate([lat, lng]);
      })
      .catch(() => {});
  };

  const renderSuggestions = () => {
    const suggestions = data
      // .filter((item) => item.terms[item.terms.length - 1].value === "Australia")
      ?.map(({ place_id, description }) => (
        <ComboboxOption key={place_id} value={description} />
      ));

    return <>{suggestions}</>;
  };

  return (
    <Combobox onSelect={handleSelect} aria-labelledby="demo">
      <ComboboxInput
        style={{ width: 300, maxWidth: "90%" }}
        value={value}
        onChange={handleInput}
        onBlur={() => {
          init();
        }}
        onClick={() => {
          init();
        }}
      />
      <ComboboxPopover>
        <ComboboxList>{status === "OK" && renderSuggestions()}</ComboboxList>
      </ComboboxPopover>
    </Combobox>
  );
}
